<div
  [class]="computedClass()"
  [class.chip--clickable]="clickable()"
  [style.background-color]="customBackgroundColor()"
  [style.color]="customColor()">
  <ng-content />
</div>
